module.exports = __webpack_public_path__ + "img/logo.3ba30d7a.png";